PJQ.views.changeRequests.ChangeRequestDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Change Requests have been created yet',
            zeroRecords: "No Change Requests matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-change-requests')
        },
        toggleRowClass: '.toggle-row',
        onViewChangeRequest: null
    },
    events: {
        'click .btn-view-change-request': 'viewChangeRequestClicked',
        'click .btn-view-prime-contract': 'viewPrimeContractClicked',
        'click .btn-view-pcco': 'viewPrimeContractChangeOrderClicked',
        'click .btn-view-commitment': 'viewCommitmentClicked',
        'click .btn-view-cco': 'viewCommitmentChangeOrderClicked',
        'click .select-line-item': 'selectLineItem',
        'click .select-all-line-items': 'selectAllLineItems',
        'click .btn-new-pcco': 'newContractChangeOrder',
        'click .btn-new-cco': 'newCommitmentChangeOrder',
        'click .btn-new-commitment': 'newCommitment',
        'click .btn-send-rfq': 'sendRFQs',
        'click .btn-existing-cco': 'addToExistingCommitmentChangeOrder',
        'click .btn-existing-pcco': 'addToExistingContractChangeOrder',
        'click .btn-existing-commitment': 'addToExistingCommitment'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
        this.options.project = this.options.project ?? PJQ.app.session.project;

        this.canAddCommitments = this.options.project.hasPermission('commitments.canAdd');
        this.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.canAddCommitmentChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.canAddContractChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.canAdd');
        this.canViewPrimeContracts = this.options.project.hasPermission('primeContracts.canView');

        if (this.options.companySettings.get('enableStandardListView')) {
            this.options.rowCallback = (row, data, index) => {
                $(row).addClass('section-row');
            };
        }
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter = this.options.userSettings.get('defaultStatusFilter');
        return defaultFilter;
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function () {
        let filterChoices = [];

        filterChoices.push({
            id: PJQ.constants.changeRequests.filterType.STATUS_FILTER,
            name: 'Status',
            choices: _.map(PJQ.constants.changeRequests.changeRequestStatus, (choice) => {
                return {
                    id: choice,
                    name: PJQ.constants.changeRequests.changeRequestStatusNames[choice]
                };
            })
        });

        if (this.options.companySettings.get('enableStandardListView')) {
            filterChoices.push({
                id: PJQ.constants.changeRequests.filterType.OTHER_FILTER,
                name: '',
                choices: [
                    {
                        id: -1,
                        name: 'Cost Not Attached'
                    },
                    {
                        id: -2,
                        name: 'Revenue Not Attached'
                    }
                ]
            });
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.change-requests-filter'),
            defaultValue: this.getDefaultFilter(),
            choices: filterChoices,
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            noneSelectedText: 'No Filters',
            onChange: (value) => {
                let statusFilter = null,
                    otherFilter = null;
                _.each(value, (filter, key) => {
                    if (key === PJQ.constants.changeRequests.filterType.STATUS_FILTER) {
                        statusFilter = filter;
                    } else if (key === PJQ.constants.changeRequests.filterType.OTHER_FILTER) {
                        otherFilter = filter;
                    }
                });

                this.setFilter(PJQ.constants.changeRequests.filterType.STATUS_FILTER, statusFilter);
                this.setFilter(PJQ.constants.changeRequests.filterType.OTHER_FILTER, otherFilter);
            }
        });

    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.changeRequests.filterType.STATUS_FILTER),
            otherFilter = this.getFilter(PJQ.constants.changeRequests.filterType.OTHER_FILTER);
        if (_.size(statusFilter) === 0 && _.size(otherFilter) === 0) {
            return this.options.data;
        }

        let res = _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });

        if (_.size(otherFilter) > 0) {
            let costNotAttached = _.contains(otherFilter, -1),
                revenueNotAttached = _.contains(otherFilter, -2);
            res = _.filter(res, function (row) {
                if (costNotAttached) {
                    return _.find(row.lineItems.models, (lineItem) => {
                        return row.canAttachLineItemCost(lineItem);
                    });
                }

                if (revenueNotAttached) {
                    return _.find(row.lineItems.models, (lineItem) => {
                        return row.canAttachLineItemRevenue(lineItem);
                    });
                }

                return false;
            });
        }

        return res;
    },
    createdRow(row, data, index) {
        if (this.options.companySettings.get('enableStandardListView')) {
            let $secondCell = $('td', row).eq(1);
            $secondCell.attr('colspan', 7);
            $('td', row).slice(2, 8).hide();
        }
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [];

        if (this.options.companySettings.get('enableStandardListView')) {
            if (!includeAllColumns) {
                columns.push({
                    "columnData": "",
                    "data": "",
                    "orderable": false,
                    "title": this.options.data.some(item => _.size(item.lineItems.models) > 0) ? `<i class="fal ${(_.size(this.expandedItems) > 0 || (this.options.expandAll && this.expandedItems == null) ? 'fa-minus-circle' : 'fa-plus-circle')} toggle-all-rows" style="cursor: pointer"></i>` : '',
                    "width": "20px",
                    "render": _.bind(function (data, type, row) {
                        let isSelected = this.options.selectedLineItems && _.size(row.lineItems) > 0 ? _.every(row.lineItems.models, item => _.contains(this.options.selectedLineItems, item.cid)) : false,
                            toggleRow = '',
                            checkbox = '',
                            erpIcon = PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());

                        if (_.size(row.lineItems.models) > 0) {
                            toggleRow += `<i class="fal fa-plus-circle toggle-row mr-2" data-type="" data-id="${row.id}" style="cursor: pointer"></i>`;
                            if (row.lineItems.some(item => item.get('appliedMarkupId') == null || item.get('appliedMarkupId') === 0)) {
                                checkbox += `<div class="text-align-center ${_.size(erpIcon) > 0 ? 'mr-2' : ''}">
                                                    <div class="pretty p-default p-smooth fs-18 m-0">
                                                        <input type="checkbox" ${isSelected ? ' checked ' : ''} class="select-all-line-items" ${1 !== 1 ? 'disabled' : ''}/>
                                                        <div class="state p-primary">
                                                            <label class="wd-0">&nbsp;</label>
                                                        </div>
                                                    </div>
                                                </div>`;
                            } else {
                                checkbox += '<div style="width: 18px;"></div>';
                            }
                        }

                        return `<div class="text-align-center d-flex ht-30p align-items-center justify-content-center">${toggleRow}${checkbox}${erpIcon}</div>`;
                    }, this)
                });
            }
            columns.push(
                {
                    "columnData": "id",
                    "data": "id",
                    "title": "Title",
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        let title = `<div class="font-weight-bold">${row.get('number')} ${_.size(row.get('title')) > 0 ? ` - ${row.get('title')}` : ''}</div>`;
                        return '<a class="btn-view-change-request" href="javascript:void(0)" data-id="' + title + '</a>';
                    }, this)
                },
                {
                    "columnData": "costCodeId",
                    "data": "costCodeId",
                    "title": "Budget Code",
                    "render": _.bind(function (data, type, row) {
                        return ``;
                    }, this)
                },
                {
                    "columnData": "description",
                    "data": "description",
                    "title": "Description",
                    "render": _.bind(function (data, type, row) {
                        return ""
                    }, this)
                },
                {
                    "columnData": "vendor",
                    "data": "vendor",
                    "title": "Company",
                    "render": _.bind(function (data, type, row) {
                        return ""
                    }, this)
                },
                {
                    "columnData": "commitmentId",
                    "data": "commitmentId",
                    "title": "Commitment",
                    "render": _.bind(function (data, type, row) {
                        return ""
                    }, this)
                },
                {
                    "columnData": "primeContractId",
                    "data": "primeContractId",
                    "title": "Contract",
                    "render": _.bind(function (data, type, row) {
                        let primeContractId = row.get('primeContractId');
                        return primeContractId && this.canViewPrimeContracts ? `<a class="btn-view-prime-contract" href="javascript:void(0)" data-id="${primeContractId}">${row.get('primeContractNumber')}</a>` : '';
                    }, this)
                },
                {
                    "columnData": "scope",
                    "data": "scope",
                    "title": "Scope",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.changeRequests.scopeNames[row.get('scope')];
                    }, this)
                },
                {
                    "columnData": "status",
                    "data": "statusId",
                    "title": "Status",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.changeRequests.changeRequestStatusNames[row.get('statusId')]
                    }, this)
                },
                {
                    "columnData": "totalAmount",
                    "data": "totalAmount",
                    "title": "Cost",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    }, this)
                },
                {
                    "columnData": "totalRevenue",
                    "data": "totalRevenue",
                    "title": "Revenue",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue'));
                    }, this)
                },
                {
                    "columnData": "markupAmount",
                    "data": "markupAmount",
                    "title": "Markup",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('markupAmount'));
                    }, this)
                },
                {
                    "columnData": "taxAmount",
                    "data": "taxAmount",
                    "title": "Tax",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                    }, this)
                },
                {
                    "columnData": "amount",
                    "data": "amount",
                    "title": "Total",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                },
                {
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-change-request ml-1" title="View change request"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    "width": "90px",
                    "className": "text-center",
                    "visible": true
                }
            );
        } else {
            let includeColumns = ['status', 'primeContract', 'client.companyName', 'number', 'title', 'description', 'scope', 'createdOn', 'amount', 'revenue', 'markupAmount', 'taxAmount', 'grandTotal'];

            if (this.options.customFields) {
                _.each(this.options.customFields.models, _.bind(function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                }, this));
            }

            if (!includeAllColumns) {
                if (this.options.settings && _.size(this.options.settings.columns) > 0)
                    includeColumns = this.options.settings.columns;
                else
                    includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

                columns.push(
                    {
                        "columnData": "childData",
                        "data": null,
                        "title": "",
                        "width": "40px",
                        "orderable": false,
                        "searchable": false,
                        "defaultContent": '',
                        "render": function (data, type, row) {
                            let toggle = '',
                                erpIcon = '';
                            erpIcon += PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                            toggle += `<i class="fal fa-plus-circle toggle-row ${_.size(erpIcon) > 0 ? 'mr-2' : ''}" data-type="" data-id="${row.id}" style="cursor: pointer"></i>`;

                            return `<div class="text-align-center d-flex">${erpIcon}</div>`;
                        }
                    });
            }

            _.each(includeColumns, _.bind(function (columnName) {
                switch (columnName) {
                    case 'status':
                        columns.push({
                            "columnData": "status",
                            "data": "attributes.statusId",
                            "title": "Status",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.constants.changeRequests.changeRequestStatusNames[row.get('statusId')]
                            }, this)
                        });
                        break;
                    case 'primeContract':
                        columns.push({
                            "columnData": "primeContract",
                            "title": "Contract",
                            "data": "attributes.primeContractNumber",
                            "orderable": true,
                            "render": _.bind(function (data, type, row) {
                                if (type === 'sort' || type === 'type') {
                                    return row.get('primeContractNumber');
                                }

                                if (this.canViewPrimeContracts) {
                                    return '<a class="btn-view-prime-contract" href="javascript:void(0)" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                                }
                                return data;
                            }, this)
                        },);
                        break;
                    case 'number':
                        columns.push({
                            "columnData": "number",
                            "data": "attributes.number",
                            "title": "Number",
                            "render": _.bind(function (data, type, row) {
                                return '<a class="btn-view-change-request" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                            }, this)
                        });
                        break;
                    case 'title':
                        columns.push({
                            "columnData": "title",
                            "data": "attributes.title",
                            "title": "Title"
                        });
                        break;
                    case 'description':
                        columns.push({
                            "columnData": "description",
                            "data": "attributes.description",
                            "title": "Description"
                        });
                        break;
                    case 'createdOn':
                        columns.push({
                            "columnData": "createdOn",
                            "data": "attributes.createdOn",
                            "title": 'Created',
                            "width": '90px',
                            "render": _.bind(function (data, type, row) {
                                if (_.size(data) === 0) {
                                    return '';
                                } else if (type === 'sort' || type === 'type') {
                                    return data ? new Date(data) : null;
                                }
                                return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }, this)
                        });
                        break;
                    case 'client.companyName':
                        columns.push({
                            "columnData": "client.companyName",
                            "title": "Client",
                            "titleSettings": "Client",
                            "render": _.bind(function (data, type, row) {
                                return row.get('client') ? row.get('client').companyName : 'N/A';
                            }, this)
                        });
                        break;
                    case 'scope':
                        columns.push({
                            "columnData": "scope",
                            "data": "attributes.scope",
                            "title": "Scope",
                            "width": "100px",
                            "render": (data, type, row) => {
                                return PJQ.constants.changeRequests.scopeNames[data] ?? '';
                            }
                        });
                        break;
                    case 'amount':
                        columns.push({
                            "columnData": "amount",
                            "data": "attributes.amount",
                            "width": "10%",
                            "title": "Cost",
                            "className": "text-align-right",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                            }, this)
                        });
                        break;
                    case 'revenue':
                        columns.push({
                            "columnData": "revenue",
                            "data": "attributes.revenue",
                            "width": "10%",
                            "title": "Revenue",
                            "className": "text-align-right",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue'));
                            }, this)
                        });
                        break;
                    case 'taxAmount':
                        columns.push({
                            "columnData": "taxAmount",
                            "data": "attributes.taxAmount",
                            "title": "Tax",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            }, this)
                        });
                        break;
                    case 'markupAmount':
                        columns.push({
                            "columnData": "markupAmount",
                            "data": "attributes.markupAmount",
                            "title": "Markup",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            }, this)
                        });
                        break;
                    case 'grandTotal':
                        columns.push({
                            "columnData": "grandTotal",
                            "data": "attributes.amount",
                            "title": "Grand Total",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                            }, this)
                        });
                        break;
                    default:
                        if (columnName.startsWith('fieldValue')) {
                            _.each(this.options.customFields.models, function (customField) {
                                if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                    columns.push({
                                        "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                        "title": customField.get('name'),
                                        "render": function (data, type, row) {
                                            let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                            fieldValue = (fieldValue !== null) ? fieldValue : '';
                                            switch (customField.get('fieldTypeId')) {
                                                case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                    if (fieldValue != null)
                                                        fieldValue = fieldValue ? 'Yes' : 'No';
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.CHOICE:
                                                    let choices = [];
                                                    // convert single choice value into array so that the logic below can work for both types.
                                                    if (typeof fieldValue === 'number')
                                                        fieldValue = [fieldValue];

                                                    _.each(customField.choices.models, _.bind(function (choice) {
                                                        if (_.find(fieldValue, function (value) {
                                                            return value === choice.get('id');
                                                        }))
                                                            choices.push(choice.get('name'));
                                                    }, this));

                                                    fieldValue = choices.join((', '));
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.DATE:
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case PJQ.constants.commitments.customFieldType.DATETIME:
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case PJQ.constants.commitments.customFieldType.INTEGER:
                                                    if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                        fieldValue = parseInt(fieldValue).toLocaleString();
                                                    }
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.MONEY:
                                                    if (type === 'sort' || type === 'type') {
                                                        if (fieldValue && fieldValue !== '$')
                                                            fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                        else
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                    }
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.PERCENT:
                                                    if (type === 'sort' || type === 'type') {
                                                        if (fieldValue && fieldValue !== '$')
                                                            fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                        else
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                    }

                                                    break;
                                            }

                                            return fieldValue;
                                        }
                                    });
                                }
                            });
                        }
                        break;
                }
            }, this));

            if (!includeAllColumns) {
                columns.push({
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-change-request ml-1" title="View change request"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    "width": "90px",
                    "className": "text-center",
                    "visible": true
                });
            }
        }

        return columns;
    },
    getLineItemColumns: function () {
        return [
            {
                "columnData": "",
                "data": "",
                "title": "",
                "width": "20px",
                "render": _.bind(function (data, type, row) {
                    let isSelected = this.options.selectedLineItems ? _.contains(this.options.selectedLineItems, row.cid) : false;

                    if (row.get('appliedMarkupId') > 0) {
                        return '';
                    } else {
                        return `<div class="d-flex text-align-center">
                                <div class="mr-2" style="width: 14px;"></div
                                <div>
                                    <div class="pretty p-default p-smooth fs-18 m-0">
                                        <input type="checkbox" ${isSelected ? ' checked ' : ''} class="select-line-item" ${1 !== 1 ? 'disabled' : ''}/>
                                        <div class="state p-primary">
                                            <label class="wd-0">&nbsp;</label>
                                        </div>
                                    </div>
                                </div>
                            </div>`;
                    }
                }, this)
            },
            {
                "columnData": "changeRequestId",
                "data": "changeRequestId",
                "title": "Change Request",
                "render": _.bind(function (data, type, row) {
                    return ``;
                }, this)
            },
            {
                "columnData": "costCodeId",
                "data": "costCodeId",
                "title": "Budget Code",
                "render": _.bind(function (data, type, row) {
                    let subJob = this.options.subJobs?.get(row.get('subJobId')),
                        costCode = this.options.costCodes?.get(row.get('costCodeId')),
                        costType = this.options.costTypes?.get(row.get('costTypeId')),
                        budgetCode;
                    return '<div>' + costCode.getDisplayName() + '</div><div class="fs-13 text-muted">' + costType.get('name') + '</div>';
                }, this)
            },
            {
                "columnData": "description",
                "data": "description",
                "title": "Description",
                "render": _.bind(function (data, type, row) {
                    return row.get('description');
                }, this)
            },
            {
                "columnData": "vendor",
                "data": "vendor",
                "title": "Company",
                "render": _.bind(function (data, type, row) {
                    let vendor = row.get('vendor');
                    return `${vendor?.companyName ?? ""}`
                }, this)
            },
            {
                "columnData": "commitmentId",
                "data": "commitmentId",
                "title": "Commitment",
                "render": _.bind(function (data, type, row) {
                    let commitmentId = row.get('commitmentId'),
                        ccoId = row.get('ccoId'),
                        html = '';

                    if (row.get('costLineItemId') > 0) {
                        html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a committed cost line item"></i>'
                    }

                    if (row.get('costLineItemId') > 0 || !this.options.canEdit) {
                        if (commitmentId > 0) {
                            html += '<div class="wd-150p"><a class="btn-view-commitment" href="javascript:void(0)" data-id="' + commitmentId + '">' + row.get('commitmentNumber') + '</a></div>';
                        } else if (ccoId > 0) {
                            html += '<div class="wd-150p"><a class="btn-view-cco" href="javascript:void(0)" data-id="' + ccoId + '" data-type="cco">' + row.get('ccoNumber') + '</a></div>';
                        }
                    }
                    return '<div class="d-flex">' + html + '</div>';
                }, this)
            },
            {
                "columnData": "primeContractId",
                "data": "primeContractId",
                "title": "Contract",
                "render": _.bind(function (data, type, row) {
                    let pccoId = row.get('pccoId'),
                        html = '';

                    if (row.get('revenueLineItemId') > 0) {
                        html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a contract change order line item"></i>'
                    }

                    if (row.get('revenueLineItemId') > 0 && pccoId > 0) {
                        if (pccoId > 0) {
                            html += '<div class="wd-150p"><a class="btn-view-pcco" href="javascript:void(0)" data-id="' + pccoId + '" data-type="pcco">' + row.get('pccoNumber') + '</a></div>';
                        }
                    }
                    return '<div class="d-flex">' + html + '</div>';
                }, this)
            },
            {
                "columnData": "scope",
                "data": "scope",
                "title": "",
                "render": _.bind(function (data, type, row) {
                    return '';
                }, this)
            },
            {
                "columnData": "statusId",
                "data": "statusId",
                "title": "Status",
                "render": _.bind(function (data, type, row) {
                    return '';
                }, this)
            },
            {
                "columnData": "amount",
                "data": "amount",
                "title": "Cost",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                }, this)
            },
            {
                "columnData": "revenue",
                "data": "revenue",
                "visible": false,
                "title": "Revenue",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue'));
                }, this)
            },
            {
                "columnData": "markupAmount",
                "data": "markupAmount",
                "title": "Markup",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('markupAmount'));
                }, this)
            },
            {
                "columnData": "taxAmount",
                "data": "taxAmount",
                "title": "Tax",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                }, this)
            },
            {
                "columnData": "amount",
                "data": "amount",
                "title": "Subtotal",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal(null, {costs: this.changeRequest.get('scope') === PJQ.constants.changeRequests.scope.INTERNAL}));
                }, this)
            },
            {
                "columnData": "",
                "data": "",
                "title": "",
                "render": (data, type, row) => {
                    return '';
                }
            }
        ]
    },
    toggleAllChildRows: function (e) {
        let self = this,
            expand = _.size(this.expandedRowIds) === 0;
        this.dataTable.rows().every(function () {
            let changeRequest = this.data();
            if (_.size(changeRequest.lineItems) > 0) {
                self.toggleChildRow(this, expand);
            }
        });
        this.renderToggleAllIcon();
    },
    selectLineItem: function (e) {
        if (this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        let $target = $(e.currentTarget),
            row = $target.closest('tr'),
            cid = row.data('row-id'),
            parentCid = row.data('parent-id'),
            parentRow = this.$(`tr#${parentCid}`),
            $selectAllToggle = parentRow.find('.select-all-line-items'),
            changeRequest = _.find(this.options.data, function (cr) {
                return cr.cid === parentCid;
            }),
            isChecked = $target.prop('checked');

        if (_.size(cid) > 0) {
            if (isChecked) {
                this.options.selectedLineItems.push(cid);
            } else {
                this.options.selectedLineItems = _.reject(this.options.selectedLineItems, function (sCid) {
                    return sCid === cid;
                });
            }
        }

        $selectAllToggle.prop('checked', _.every(changeRequest.lineItems.models, item => _.contains(this.options.selectedLineItems, item.cid)));
        this.updateBulkActionsButton();
    },
    selectAllLineItems: function (e) {
        let $target = $(e.currentTarget),
            parentCid = $target.closest('tr').attr('id'),
            changeRequest = _.find(this.options.data, function (cr) {
                return cr.cid === parentCid;
            });

        if (this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        let nonAppliedLines = _.filter(changeRequest.lineItems.models, function (li) {
            return li.get('appliedMarkupId') == null || li.get('appliedMarkupId') === 0;
        });

        let nonAppliedCids = _.map(nonAppliedLines, 'cid');

        if ($target.prop('checked')) {
            this.options.selectedLineItems = _.union(this.options.selectedLineItems, nonAppliedCids);
        } else {
            this.options.selectedLineItems = _.difference(this.options.selectedLineItems, nonAppliedCids);
        }

        this.$(`tr#${parentCid}`).find('.select-line-item').prop('checked', $target.prop('checked'));
        this.$(`tr[data-parent-id="${changeRequest.cid}"]`).each((index, tr) => {
            $(tr).find('.select-line-item').prop('checked', $target.prop('checked'));
        });

        this.updateBulkActionsButton();
    },
    updateBulkActionsButton: function () {
        let bulkActionsButton = this.$('.btn-bulk-actions'),
            contractsSubmenu = this.$('.contracts-submenu'),
            commitmentsSubmenu = this.$('.commitments-submenu'),
            addCCOButton = this.$('.btn-add-cco'),
            addSubcontractButtons = this.$('.btn-new-commitment'),
            sendRFQButton = this.$('.btn-send-rfq');

        let changeRequests = _.uniq(_.map(this.options.selectedLineItems, (cid) => {
            return _.find(this.options.data, (cr) => {
                return _.some(cr.lineItems.models, (item) => item.cid === cid);
            });
        }));
        changeRequests = _.compact(changeRequests);

        if (_.size(this.options.selectedLineItems) > 0) {
            bulkActionsButton.removeClass('disabled');
        } else {
            bulkActionsButton.addClass('disabled');
            return;
        }

        let canSendRFQ = !_.some(changeRequests, (cr) => !cr.canSendRFQ()),
            allPrimeContractIdsMatch = _.every(changeRequests, (cr, index, array) =>
                cr.get('primeContractId') === array[0].get('primeContractId')
            ),
            canAttachCosts = true,
            canAttachRevenue = allPrimeContractIdsMatch;
        if (_.size(this.options.selectedLineItems) > 0) {
            this.$('.btn-create-new').removeClass('disabled');

            _.each(changeRequests, (changeRequest) => {
                _.each(changeRequest.lineItems.get(this.options.selectedLineItems), (lineItem) => {
                    if (!changeRequest.canAttachLineItemCost(lineItem)) {
                        canAttachCosts = false;
                    }

                    if (!changeRequest.canAttachLineItemRevenue(lineItem)) {
                        canAttachRevenue = false;
                    }
                });
            });
        }

        if (!canAttachRevenue || !this.canAddContractChangeOrders) {
            contractsSubmenu.addClass('disabled');
        } else {
            contractsSubmenu.removeClass('disabled');
        }

        if (!canAttachCosts) {
            commitmentsSubmenu.addClass('disabled');
        } else {
            commitmentsSubmenu.removeClass('disabled');
        }

        if (!this.canAddCommitments) {
            addSubcontractButtons.addClass('hidden');
        } else {
            addSubcontractButtons.removeClass('hidden');
        }

        if (!this.canAddCommitmentChangeOrders) {
            addCCOButton.addClass('hidden');
        } else {
            addCCOButton.removeClass('hidden');
        }

        if (!canSendRFQ) {
            sendRFQButton.addClass('disabled');
        } else {
            sendRFQButton.removeClass('disabled');
        }
    },
    newCommitment: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentType = $(e.currentTarget).hasClass('new-po') ? PJQ.constants.commitments.commitmentType.PURCHASE_ORDER : PJQ.constants.commitments.commitmentType.SUBCONTRACT,
            lineItems = [],
            selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
            })),
            vendors = [],
            vendorIds = [];
        _.each(selLineItems, function (lineItem) {
            if (lineItem.get('costLineItemId') == null) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    changeRequestLineItemId: lineItem.id
                }));

                let liVendor = lineItem.get('vendor');
                if (vendors == null) {
                    return;
                } else if (liVendor && vendorIds.indexOf(liVendor.id) === -1) {
                    vendors.length > 0 ? null : vendors.push(liVendor);
                }
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.commitments.CommitmentEditModal({
                model: null,
                fromChangeRequest: this.model,
                contractedContact: vendors.length > 0 ? vendors[0] : null,
                commitmentType: commitmentType,
                lineItems: lineItems,
                onSave: _.bind(function (commitment) {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                }, this),
            });
        }
    },
    newCommitmentChangeOrder: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            filterStatuses: PJQ.constants.commitments.commitmentStatus.APPROVED,
            headerSubText: 'Select the Commitment you would like to create a Change Order for.',
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                        return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                    })),
                    lineItems = [];

                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        lineItems.push(_.extend(lineItem.attributes, {
                            id: null,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                if (_.size(lineItems) > 0) {
                    new PJQ.views.commitments.ChangeOrderEditModal({
                        commitment: commitment,
                        lineItems: lineItems,
                        onSave: _.bind(function (changeOrder) {
                            if (typeof this.options.onCreateFromLineItems === 'function') {
                                this.options.onCreateFromLineItems();
                            }
                        }, this),
                    });
                }
            }
        });
    },
    getSelectedCommitmentIds: async function () {
        let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
            return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
        }));

        return _.uniq(_.map(selLineItems, (item) => item.get('commitmentId')));
    },
    sendRFQs: async function (e) {
        let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
            })),
            changeRequests = _.uniq(_.map(this.options.selectedLineItems, (cid) => {
                return _.find(this.options.data, (cr) => {
                    return _.some(cr.lineItems.models, (item) => item.cid === cid);
                });
            })),
            projectCommitments = new PJQ.collections.commitments.Commitments([], {
                projectId: this.options.project.id,
                withLineItems: true
            });

        await projectCommitments.fetch();
        changeRequests = _.compact(changeRequests);

        let fnSendRFQ = (lineItems) => {
            new PJQ.views.rfq.RFQBatchModal({
                changeRequests: changeRequests,
                project: this.options.project,
                lineItems: lineItems,
                projectCommitments: projectCommitments
            });
        };

        let lineItemCt = _.size(selLineItems),
            rfqItemsCt = _.filter(selLineItems, (lineItem) => {
                return lineItem.get('rfqId') > 0;
            }).length;
        if (rfqItemsCt > 0) {
            if (rfqItemsCt === lineItemCt) {
                new PJQ.views.modals.YesNo({
                    header: "Send New RFQs?",
                    body: "All of the selected line items are already associated with RFQs. Would you like to create them again?",
                    onYes: () => {
                        fnSendRFQ(selLineItems);
                    }
                });
            } else {
                new PJQ.views.BaseModal({
                    header: "Send RFQs",
                    body: "Some of the selected line items are already associated with RFQs. Please choose from the options below.",
                    isShowOkButton: true,
                    okButtonText: "Create All (" + lineItemCt + ")",
                    onOk: () => {
                        fnSendRFQ(selLineItems);
                    },
                    isShowSecondaryButton: true,
                    secondaryButtonColorClass: 'primary',
                    secondaryButtonText: "Create Missing (" + rfqItemsCt + ")",
                    onSecondary: () => {
                        fnSendRFQ(_.filter(selLineItems, (lineItem) => {
                            return !(lineItem.get('rfqId') > 0);
                        }));
                    }
                });
            }
        } else {
            fnSendRFQ(selLineItems);
        }
    },
    newContractChangeOrder: async function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let lineItems = [],
            selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
            })),
            changeRequestId = selLineItems[0].get('changeRequestId'),
            changeRequest = _.find(this.options.data, (cr) => cr.id === changeRequestId),
            primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: changeRequest.get('primeContractId')
            });
        await primeContract.fetch();

        _.each(selLineItems, function (lineItem) {
            if (!lineItem.get('revenueLineItemId')) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    amount: lineItem.get('revenue'),
                    changeRequestLineItemId: lineItem.id
                }));
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.primeContracts.ChangeOrderEditModal({
                primeContract: primeContract,
                lineItems: lineItems,
                onSave: (commitment) => {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                },
            });
        }
    },
    addToExistingCommitment: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            headerSubText: 'Select the Commitment you would like to add these line items to',
            filterStatuses: [
                PJQ.constants.commitments.commitmentStatus.DRAFT,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING,
                PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID,
                PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE,
                PJQ.constants.commitments.commitmentStatus.SUBMITTED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PARTIALLY_RECEIVED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_RECEIVED
            ],
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                    return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                }));
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        commitment.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            commitmentId: commitment.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.CommitmentEditModal({
                    model: commitment,
                    fetch: false,
                    onSave: _.bind(function (commitment) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    addToExistingCommitmentChangeOrder: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.commitments.SelectCommitmentChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Commitment Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.commitments.changeOrderStatus.DRAFT,
                PJQ.constants.commitments.changeOrderStatus.NO_CHARGE,
                PJQ.constants.commitments.changeOrderStatus.IN_REVIEW,
                PJQ.constants.commitments.changeOrderStatus.NOT_PRICING,
                PJQ.constants.commitments.changeOrderStatus.PRICING,
                PJQ.constants.commitments.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                    return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                }));
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    addToExistingContractChangeOrder: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.primeContracts.SelectChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Contract Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                PJQ.constants.primeContracts.changeOrderStatus.NO_CHARGE,
                PJQ.constants.primeContracts.changeOrderStatus.IN_REVIEW,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                    return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                }));
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('revenueLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    viewCommitmentClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewCommitment(id);
    },
    viewCommitment: function (commitmentId) {
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: commitmentId
            })
        });
    },
    viewCommitmentChangeOrderClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewCommitmentChangeOrder(id);
    },
    viewCommitmentChangeOrder: function (changeOrderId) {
        new PJQ.views.commitments.ChangeOrderEditModal({
            model: new PJQ.models.commitments.ChangeOrder({
                id: changeOrderId
            })
        });
    },
    getRowChildData: function (row) {
        this.changeRequest = row.data();
        let fnReturnData = (lineItems) => {
            return _.sortBy(_.filter(lineItems, (item) => !item.get('delete')), function (model) {
                return model.get('id');
            });
        }

        let otherFilter = this.getFilter(PJQ.constants.changeRequests.filterType.OTHER_FILTER),
            costNotAttached = _.contains(otherFilter, -1),
            revenueNotAttached = _.contains(otherFilter, -2);
        return _.sortBy(_.filter(this.changeRequest.lineItems.models, (item) => {
            if (item.get('delete')) {
                return false;
            }

            if (costNotAttached) {
                return this.changeRequest.canAttachLineItemCost(item);
            } else if (revenueNotAttached) {
                return this.changeRequest.canAttachLineItemRevenue(item);
            }
            return true;
        }), function (model) {
            return model.get('id');
        });
    },
    getRowChildColumns: function (row) {
        return this.getLineItemColumns();
    },
    onChildRowToggle: function (row) {
        let $row = $(row.node());
        let $icon = $row.find('.toggle-row');
    },
    preserveScrollRender: function () {
        let scrollTop = $(window).scrollTop();
        this.render();
        $(window).scrollTop(scrollTop);
    },
    viewChangeRequestClicked: function (e) {
        if (typeof (this.options.onViewChangeRequest) === 'function') {
            let row = this.getRow((e.currentTarget).closest('tr')),
                invoice = row.data();
            if (invoice != null) {
                this.options.onViewChangeRequest(invoice);
            }
        }
    },
    viewPrimeContractClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewPrimeContract(id);
    },
    viewPrimeContract: function (primeContractId) {
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: primeContractId
            })
        });
    },
    viewPrimeContractChangeOrderClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewPrimeContractChangeOrder(id);
    },
    viewPrimeContractChangeOrder: function (changeOrderId) {
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            model: new PJQ.models.primeContracts.ChangeOrder({
                id: changeOrderId
            })
        });
    }
});